// @vendors
const { Promise } = require('es6-promise');

// @utils
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');
const { BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_10 } = require('constants/index');

const getResultsFailure = (response, term) => {
    return {
        type: actionTypes.BROKER_SEARCH_PRODUCT_FAILURE,
        payload: {
            data: response,
            term
        }
    };
};

const getLimitedResultsSuccess = (response, term) => {
    return {
        type: actionTypes.BROKER_LIMITED_SEARCH_PRODUCT_SUCCESS,
        payload: {
            data: response,
            term
        }
    };
};

const getResultsSuccess = (response, term) => {
    return {
        type: actionTypes.BROKER_SEARCH_PRODUCT_SUCCESS,
        payload: {
            data: response,
            term
        }
    };
};

const getResultsFetching = (term) => {
    return {
        type: actionTypes.BROKER_SEARCH_PRODUCT_FETCHING,
        payload: {
            isFetching: true,
            term
        }
    };
};


const setPlansTypeList = plansToReturn => {
    return {
        type: actionTypes.BROKER_SEARCH_SET_PLANS_LIST,
        payload: plansToReturn
    };
};

const getResultsListRequest = (term, pageSize, plansToReturn, dispatch, limitResultSet) => {
    return new Promise(() => {

        const requestData = {
            query: {
                pageNum: "1",
                pageSize: (pageSize ? pageSize : BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_10)
            }
        };

        dispatch(getResultsFetching(term));
        if (plansToReturn) {
            dispatch(setPlansTypeList(plansToReturn));
        }

        APIGet(dispatch, apiURLBuilder.getURL('brokerSimpleSearch', {term: term}), requestData)
            .then(response => {
                if (limitResultSet) {
                    dispatch(getLimitedResultsSuccess(response, term));
                }
                else {
                    dispatch(getResultsSuccess(response, term));
                }
            }, response => {
                dispatch(getResultsFailure(response, term));
            }
        );
    });
};

const searchProduct = (term, pageSize, plansToReturn) => (dispatch) => (getResultsListRequest(term, pageSize, plansToReturn, dispatch, true));

const searchAllProducts = (term) => (dispatch) => (getResultsListRequest(term, null, null, dispatch));

const clearResults = () => {
    return {
        type: actionTypes.BROKER_SEARCH_PRODUCT_RESET
    };
};

const resetSelectedResults = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_SEARCH_SELECTED_RESULT_RESET
    })
}

module.exports = {
    resetSelectedResults,
    searchAllProducts,
    searchProduct,
    clearResults
};
